module.exports = __webpack_public_path__ + "f11378d8cd569374ade6a8b2f25623ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/QR_code.jpg
// module id = dkkB
// module chunks = 3